// Module
var code = " <input type=\"checkbox\" ng-model=\"workflowItem.Value\" ng-disabled=\"workflowItem.Status !== 'Active' || !stateController.checkRole(workflowItem.EffectiveRole)\" ng-checked=\"workflowItem.Value\" class=\"form-select form-select-sm\" style=\"float:right;margin-right:20px\" ng-change=\"stateController.onClickSubmit(workflowItem)\"/> ";
// Exports
export default code;